/* Card primitive. Pure code-motion from src/App.jsx (Phase 2 group 3). */

import { brand } from './brand.js';

export const cardStyle = {
  backgroundColor: brand.white,
  borderRadius: "12px",
  border: `1px solid ${brand.borderLight}`,
  padding: "24px",
  boxShadow: "0 1px 3px rgba(8,49,77,0.06)",
};
